module.exports = self["configApp"];